import React, {useEffect, useRef, useState} from "react";
import {v4 as uuidv4} from 'uuid';

const MyForm = ({
	children,
	onSubmit = ()=>{}
								}) => {
	return (
		<form className='sf-form' onSubmit={onSubmit}>
			{children}
		</form>
	)
}

export const Input = React.memo((
	{
		name = '',
		label = '',
		type = 'text',
		full = false,
		placeholder = '',
		defaultValue = '',
		required = false,
		onChange = () => {
		}
	}
) => {
	const htmlFor = name ? name : uuidv4()
	const [focus, setFocus] = useState(false)
	const onFocus = () => setFocus(true)
	const onBlur = () => setFocus(false)
	return (
		<div className={`my-form-group ${full ? 'full' : ''} ${focus ? 'active' : ''}`}>
			<label htmlFor={htmlFor}>{label}</label>
			<input required={required} type={type} name={htmlFor} placeholder={placeholder} defaultValue={defaultValue} onBlur={onBlur}
						 onFocus={onFocus} onChange={onChange}/>
		</div>
	)
})

export const Select = React.memo(({
									items = [],
									defaultValue = null,
									isMulti = false,
									onChange = () => {}
								}) => {
	const inputRef = useRef()
	const selectWrapRef = useRef()

	const [selected, setSelected] = useState(isMulti ? [] : null)

	useEffect(() => {
		if (defaultValue !== null) {
			if(isMulti){
				if(!defaultValue instanceof Array) return
				let foundValues = []
				defaultValue.forEach(item=>{
					const findByValue = items.find(q=>q.value === item)
					if(findByValue) foundValues.push(findByValue)
				})
				setSelected(foundValues)
			}else {
				const findByValue = items.find(q=>q.value === defaultValue)
				if(findByValue) setSelected(findByValue)
			}
		}
	}, [items])

	useEffect(() => {
		if(!selected) return
		onChange(isMulti ? selected.map(item=>item.value) : selected.value)
	}, [selected])

	const [search, setSearch] = useState('')

	const setSearchData = (e) => {
		const v = e.target.value
		setSearch(v)
	}

	const showSelected = isMulti ? selected : selected ? [selected] : []

	const searchFilter = (q) => {
		if (search) {
			const regxString = `.*${search.toLowerCase()}.*`
			const regx = new RegExp(regxString)
			return q.label.toLowerCase().match(regx)
		}
		return true
	}
	const selectedFilter = (q) => {
		const find = showSelected.find(sq => JSON.stringify(q) === JSON.stringify(sq))
		return !find
	}
	const normalizeSelect = (q) => {
		return typeof q === "object" && typeof q.label !== "undefined" && typeof q.value !== "undefined"
	}

	const [active, setActive] = useState(false)

	function handleClickOutside(event) {
		if (selectWrapRef.current && !selectWrapRef.current.contains(event.target)) setActive(false)
	}

	const doFocus = () => {
		inputRef.current.focus()
	}

	const toggleActive = (force = null) => {
		setActive(p => {
			if (!p) {
				doFocus()
				document.addEventListener("mousedown", handleClickOutside);
			} else {
				document.removeEventListener("mousedown", handleClickOutside);
			}
			return force ? force : !p
		})
	}

	const selectItem = (item) => {
		setSelected(p => {
			if (isMulti) return [...p, item]
			return item
		})
		if(isMulti) {
			doFocus()
		}else{
			toggleActive(false)
		}
	}
	const removeItem = (item) => {
		setSelected(p => {
			if (isMulti) return p.filter(q => JSON.stringify(q) !== JSON.stringify(item))
			return null
		})
	}

	return (
		<div className='my-form-select'>
			<div ref={selectWrapRef} className='select-wrap'>
				<div className='selector-div'>
					<input ref={inputRef} onClick={() => toggleActive(true)} onChange={setSearchData} defaultValue={search}
								 placeholder="انتخاب کنید"/>
					<div onClick={() => toggleActive()}>
						<svg
							viewBox="0 0 1024 1024"
							fill="currentColor"
							height="1em"
							width="1em"
						>
							<path
								d="M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0048.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z"/>
						</svg>
					</div>
				</div>


				<div className={`select-items ${active ? 'active' : ''}`}>
					{items.filter(normalizeSelect).filter(searchFilter).filter(selectedFilter).map((item, index) =>
						<span onClick={() => selectItem(item)} key={index}>{item.label}</span>
					)}
				</div>
			</div>
			<div className='selected-wrap'>
				<ul>
					{showSelected.map((item, index) =>
						<li key={index}>
							<span onClick={() => removeItem(item)}>×</span>
							<p>{item.label}</p>
						</li>)}
				</ul>

			</div>

		</div>
	)
})

export const Section = React.memo(({title = '', children}) => {
	return (
		<div className={'my-form-section'}>
			<h3>{title}</h3>
			{children}
		</div>
	)
})

export const TextArea = React.memo(({
	placeholder = '',
	children = '',
	required = false,
	onChange = ()=>{}
									}) => {
	return (
		<div className='my-text-area'>
			<textarea required={required} placeholder={placeholder} onChange={onChange}>{children}</textarea>
		</div>
	)
})

export const Switch = React.memo(({
	label = '',
	defaultChecked = false,
	required = false,
	onChange = ()=>{}
									}) => {
	return (
		<div className='my-check-switch'>
			<span className='switch-label'>{label}</span>
			<label className="switch">
				<input key={defaultChecked} onChange={onChange} required={required} type="checkbox" defaultChecked={defaultChecked}/>
				<span className="slider round"/>
			</label>
		</div>
	)
})

export const Sumbit = React.memo(({
	children = 'ذخیره',
	align = '',
	loading=false
								}) => {
	return (
		<div className={`my-submit-btn ${align === 'left' ? 'txleft' : align === 'center' ? 'txcenter' : ''}`}>
			<button disabled={loading} type="submit">{children}</button>
		</div>
	)
})
export const Delete = React.memo(({
	children = 'حذف',
	align = '',
	loading=false,
	onClick=()=>{}
								}) => {
	return (
		<div className={`my-submit-btn delete ${align === 'left' ? 'txleft' : align === 'center' ? 'txcenter' : ''}`}>
			<button onClick={onClick} disabled={loading} type="button">{children}</button>
		</div>
	)
})
export default React.memo(MyForm);